<template>
  <section id="planes">
    <div class="planes-header">
      <h2>Planes a Medida</h2>
      <p>Soluciones escalables diseñadas para adaptarse al crecimiento de tu negocio digital</p>
    </div>

    <div class="planes-content">
      <article class="plan-card">
        <div class="plan-top">
          <h4>Hosting</h4>
          <div class="price">
            <span class="currency">$</span>
            <span class="amount">30</span>
            <span class="period">/mes</span>
          </div>
          <p class="plan-desc">Ideal para proyectos iniciales o landing pages.</p>
        </div>
        <ul class="features">
          <li><i class='bx bx-check'></i> Alojamiento de proyecto</li>
          <li><i class='bx bx-check'></i> Correo corporativo</li>
          <li><i class='bx bx-check'></i> Buen Rendimiento</li>
        </ul>
        <a href="#dudas" class="plan-btn btn-outline">Consultar</a>
      </article>

      <article class="plan-card popular">
        <div class="popular-badge">Más Elegido</div>
        <div class="plan-top">
          <h4>Desarrollo</h4>
          <div class="price">
            <span class="currency">$</span>
            <span class="amount">200</span>
            <span class="period">/mes</span>
          </div>
          <p class="plan-desc">Solución completa para empresas en expansión.</p>
        </div>
        <ul class="features">
          <li><i class='bx bx-check'></i> Desarrollo de proyecto</li>
          <li><i class='bx bx-check'></i> Mantenimiento y subida</li>
          <li><i class='bx bx-check'></i> Hosting y correo</li>
        </ul>
        <a href="#dudas" class="plan-btn btn-solid">Empezar Ahora</a>
      </article>

      <article class="plan-card">
        <div class="plan-top">
          <h4>Desarrollo +</h4>
          <div class="price">
            <span class="amount-custom">Cotizar</span>
          </div>
          <p class="plan-desc">Sistemas complejos y aplicaciones a medida.</p>
        </div>
        <ul class="features">
          <li><i class='bx bx-check'></i> Desarrollos a medida</li>
          <li><i class='bx bx-check'></i> Mantenimiento opcional</li>
          <li><i class='bx bx-check'></i> Despliegues y Hosting</li>
        </ul>
        <a href="#dudas" class="plan-btn btn-outline">Contactar Ventas</a>
      </article>
    </div>
  </section>
</template>

<style scoped lang="scss">
#planes {
  width: 100%;
  padding: 6rem 2rem;
  background: var(--bg-color);
  position: relative;
}

.planes-header {
  text-align: center;
  max-width: 600px;
  margin: 0 auto 5rem auto;

  h2 {
    width: 100%;
    font-size: 2.5rem;
    color: var(--text-main);
    margin-bottom: 1rem !important;
  }

  p {
    font-size: 1.1rem;
    color: var(--text-muted);
  }
}

.planes-content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  flex-wrap: wrap;
}

.plan-card {
  background: white;
  border-radius: 24px;
  padding: 2.5rem 2rem;
  width: 100%;
  max-width: 340px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all var(--duration);
  display: flex;
  flex-direction: column;
  position: relative;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  }

  &.popular {
    transform: scale(1.05);
    border: 2px solid var(--primary);
    box-shadow: 0 20px 40px rgba(79, 70, 229, 0.15);

    &:hover {
      transform: scale(1.05) translateY(-5px);
    }
  }
}

.popular-badge {
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--primary);
  color: white;
  padding: 0.4rem 1.2rem;
  border-radius: 50px;
  font-size: 0.85rem;
  font-weight: 600;
  white-space: nowrap;
}

.plan-top {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding-bottom: 2rem;
  margin-bottom: 2rem;

  h4 {
    font-size: 1.2rem;
    color: var(--text-main);
    margin-bottom: 1rem !important;
  }
}

.price {
  margin-bottom: 1rem;
  color: var(--text-main);

  .currency {
    font-size: 1.5rem;
    font-weight: 600;
    vertical-align: top;
  }

  .amount {
    font-size: 3rem;
    font-weight: 800;
    line-height: 1;
    letter-spacing: -1px;
  }

  .period {
    color: var(--text-muted);
    font-size: 1rem;
  }

  .amount-custom {
    font-size: 2.5rem;
    font-weight: 800;
    line-height: 1;
    letter-spacing: -1px;
  }
}

.plan-desc {
  font-size: 0.95rem;
  color: var(--text-muted);
  line-height: 1.5;
}

.features {
  list-style: none;
  padding: 0;
  margin: 0 0 2rem 0;
  flex-grow: 1;



  li {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    margin-bottom: 1rem;
    color: var(--text-main);
    font-size: 0.95rem;

    i {
      color: var(--primary);
      font-size: 1.2rem;
      background: rgba(79, 70, 229, 0.1);
      border-radius: 50%;
      padding: 0.2rem;
    }
  }
}

.plan-btn {
  text-align: center;
  padding: 1rem;
  border-radius: 12px;
  font-weight: 600;
  text-decoration: none;
  transition: all var(--duration);
  margin-top: auto;
}

.btn-outline {
  background: white;
  color: var(--text-main) !important;
  border: 1px solid rgba(0, 0, 0, 0.1);

  &:hover {
    background: rgba(0, 0, 0, 0.03);
    border-color: rgba(0, 0, 0, 0.2);
  }
}

.btn-solid {
  background: var(--primary);
  color: white !important;
  box-shadow: 0 4px 14px var(--primary-glow);

  &:hover {
    background: var(--secondary);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4);
  }
}

@media screen and (max-width: 1024px) {
  .plan-card.popular {
    transform: scale(1);

    &:hover {
      transform: translateY(-5px);
    }
  }
}

@media screen and (max-width: 768px) {
  #planes {
    padding: 4rem 1rem;
  }

  .planes-content {
    gap: 3rem;
  }
}
</style>
<script setup lang="ts">
</script>